// 监控详情
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, theme, Button, InputNumber, message, Popconfirm, Form, } from 'antd'
import { SwapOutlined, LoadingOutlined, DownloadOutlined, SyncOutlined, VerticalAlignBottomOutlined, PauseOutlined, CaretRightOutlined, StopOutlined } from '@ant-design/icons'

import AirportTypeInfo from './airport_type_info.js'
import AirportHealthStatus from './airport_health_status.js'
import UAVTypeInfo from './UAV_type_info.js'
import Operator from './operator.js'
import Megaphone from './megaphone.js'
import LiveVideo from './live_video.js'


import dayjs from 'dayjs';

import { transformGCJ2WGS, transformWGSGCJ2, demoMap, distance, debounce } from "@/common/js/common.js" //引入公共方法
import { GetAltitude } from '@/server/line' //接口 通过经纬度获取海拔（84坐标系）
import { getWebSocketAddress, getM30AirportNumber, goToPointByFlyTo, stopFlytoAPI, cancelReturnFlightAPI, goToPointByTakeoff, returnHome, getLinePointApi, getKmlLinePointApi, updateJobStatusAPI } from '@/server/commandFlight.js'

import peg from "@/common/img/peg.png" //标识桩
import map_jc from "@/common/img/command_flight/map_jc.svg" //机场
import map_dd from "@/common/img/command_flight/map_dd.svg" //flyto点位
import map_uavJT from "@/common/img/command_flight/map_uavJT.svg" //无人机箭头

function SurveillanceInfo () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const dock_id = location.search.slice(1).split('&')[0];//航线id
  const token = localStorage.getItem('dock_token');
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色

  const mapRef = useRef(undefined);//地图实例
  const ws = useRef(null);//WebSocket实例
  const closeWs = useRef(false)//是否可以重启ws

  const [globalStatus, setGlobalStatus] = useState({//全局状态
    hasFlyTask: false,//当前是否存在飞行任务(通过是否获取到管线确定)
    stopTask: false,//当前航线任务是否被停止
    firstStatus: 1,//一级状态            1:监控    2:指令
    secondStatus: 0,//二级状态   0:待机 1:起飞中 2:任务中 3:到达指定位置  4:选中目标位置 5:暂停  6:继续  7:返航  8:停止
    taskLoading: false,//任务中loading
    returnLoading: false,//返航loading
    isShowPopconfirm: false,//是否  点击返航
  })
  // const secondStatusRef = useRef(0)//二级状态  监听
  const taskLoadingRef = useRef(false)//任务中loading  监听

  const hasFlyTaskRef = useRef(false)//是否存在航线任务

  const mainStatusRef = useRef(1)//主状态  1:监控 2:指令
  const [mainStatus, setMainStatus] = useState(1)//主状态  1:监控 2:指令
  const monitor_statusRef = useRef(1)//监控-状态  1:飞行中   2:暂停中
  const secondStatusRef = useRef(1)//指令-状态  0:待机 1:起飞中 2:任务中 3:到达指定位置  4:选中目标位置 5:暂停  6:继续  7:返航  8:停止  9:未开机

  const takeoffLoadingRef = useRef(false)//起飞中···
  const flytoLoadingRef = useRef(false)//任务中···

  const droneStatusRef = useRef('P')//挡位    P:停止   A:指点飞行    M:操作盘(手动飞行)


  const uav_mode_code_state = useRef('')//无人机返回状态

  const isCompute = useRef(false)//是否 计算海拔中

  const [anchorPointForm] = Form.useForm();//表单实例
  const [coordinatePointInfo, setCoordinatePointInfo] = useState({//表单
    lng: '',//经度
    lat: '',//纬度
    cruiseSpeed: 15,//巡航速度
    takeoffAltitude: 80,//起飞高度
    takeoffElevation: 0,//takeoff机场海拔
    surfaceElevation: 0,//地表海拔
    reachingAltitude: 0,//到达高度
    returnAltitude: 0,//返航海拔
    lastFlightAltitude: 0,//上次飞行时候的高度
  })// 坐标点的经纬度信息

  const [anchorPoint, setAnchorPoint] = useState([])//选定的定点位置
  const [anchorPointsList, setAnchorPointsList] = useState([])//选定的定点集合

  const [dockInfo, setDockInfo] = useState({})//机场信息

  const [pipelineAndPoint, setPipelineAndPoint] = useState({//管线及航点坐标
    pipeline: [],//管线坐标
    waypointCoordinates: [],//航点坐标
  })

  const [airportCoordinate, setAirportCoordinate] = useState([0, 0])//机场坐标
  const [uavCoordinate, setUAVCoordinate] = useState([0, 0])//无人机坐标
  const [airportData, setAirportData] = useState({})//ws中  机场
  const [UAVData, setUAVData] = useState({})//ws中  无人机

  const [megaphoneType, setMegaphoneType] = useState(0)//0:暂无信息  1:文字喊话  2:文件喊话

  const [lineList, setLineList] = useState([])//获取到的航线列表信息

  const uav_mode_code_reason_dic = {//飞行器进入当前状态的原因  字典
    0: "无意义",
    1: "电池电量不足（返航、降落）",
    2: "电池电压不足（返航、降落）",
    3: "电压严重过低（返航、降落）",
    4: "遥控器按键请求（起飞、返航、降落）",
    5: "App 请求（起飞、返航、降落）",
    6: "遥控信号丢失（返航、降落、悬停）",
    7: "导航、SDK 等外部设备触发（起飞、返航、降落）",
    8: "进入机场限飞区（降落）",
    9: "虽然触发了返航但是因为距离 Home 点距离太近（降落）",
    10: "虽然触发了返航但是因为距离 Home 点距离太远（降落）",
    11: "执行航点任务时请求（起飞）",
    12: "返航阶段到达 Home 点上方后请求（降落）",
    13: "飞行器高度下降，距地面 0.7m（二段降落限低）时，继续下降导致（降落）",
    14: "App、SDK 等设备强制突破限低保护进行（降落）",
    15: "因为周围有航班经过而请求（返航、降落）",
    16: "因为高度控制失败请求（返航、降落）",
    17: "智能低电量返航后进入（降落）",
    18: "AP控制飞行模式（手动飞行）",
    19: "硬件异常（返航、降落）",
    20: "防触地保护结束（降落）",
    21: "返航取消 (悬停)",
    22: "返航时遇到障碍物（降落）",
    23: "机场场景下大风触发（返航）"
  }

  const uav_mode_code_dic = {//无人机状态  字典
    0: "待机",
    1: "起飞准备",
    2: "起飞准备完毕",
    3: "手动飞行",
    4: "自动起飞",
    5: "航线飞行",
    6: "全景拍照",
    7: "智能跟随",
    8: "ADS-B 躲避",
    9: "自动返航",
    10: "自动降落",
    11: "强制降落",
    12: "三桨叶降落",
    13: "升级中",
    14: "未连接",
    15: "APAS",
    16: "虚拟摇杆状态",
    17: "指令飞行",
    18: "空中 RTK 收敛模式",
    19: "机场选址中"
  }

  const getAirportNumberByToken = async () => {// 进入页面即刻获取状态信息  用以确定是否展示前端页面
    if (ws.current) {
      ws.current.close()
      ws.current = null
    }
    let coo = coordinatePointInfo
    let glo = globalStatus
    let pip = pipelineAndPoint
    let obj = {
      access_token: token,
      CompanyID: localStorage.getItem('dock_CompanyID'),
      dock_id: dock_id
    }
    let res = await getM30AirportNumber(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错啦，请稍后重试！');
      glo.title = res.msg
      setGlobalStatus({ ...glo })
      return
    }
    if ((res?.data?.dock_info?.Rtype === 10 || res?.data?.dock_info?.Rtype === 11) && res?.data?.dock_info?.InsID !== 0) { getRoutesPoint() }
    setDockInfo({ ...res?.data?.dock_info })
    mapRef.current.setView(res.data.dock_info.latitude ? [Number(res.data.dock_info.latitude), Number(res.data.dock_info.longitude)] : undefined)
    getWebSocket(res.data.dock_info.aircraftSn, res.data.dock_info.dockSn)
    // 管线   转84
    let RoutesPoints = []
    if (res?.data?.Routes_Points) {
      res.data.Routes_Points.forEach((res) => {
        let d = transformGCJ2WGS({ lat: res.latitude, lon: res.longitude });
        let arr = [Number(parseFloat(d.lon).toFixed(7)), Number(parseFloat(d.lat).toFixed(7))];
        RoutesPoints.push(arr)
      })
    }

    // 航点   转84
    let InsPoints = []
    if (res?.data?.Ins_Points) {
      res.data.Ins_Points.forEach((res) => {
        let d = transformGCJ2WGS({ lat: res.latitude, lon: res.longitude });
        let arr = [Number(parseFloat(d.lon).toFixed(7)), Number(parseFloat(d.lat).toFixed(7))];
        // let arr = [res.longitude, res.latitude]
        InsPoints.push(arr)
      })
    }

    pip.pipeline = RoutesPoints
    pip.waypointCoordinates = InsPoints
    setPipelineAndPoint({ ...pip })

    secondStatusRef.current = 0
    hasFlyTaskRef.current = InsPoints.length > 0

    coo.lng = res.data.dock_info.docklatlng_84.split(',')[1]//经度
    coo.lat = res.data.dock_info.docklatlng_84.split(',')[0]//纬度
    coo.takeoffElevation = res.data.dock_info.dockAlt
    coo.surfaceElevation = res.data.dock_info.dockAlt
    coo.lastFlightAltitude = res.data.dock_info.dockAlt
    anchorPointForm.setFieldsValue({
      lng: res.data.dock_info.docklatlng_84.split(',')[1],//经度
      lat: res.data.dock_info.docklatlng_84.split(',')[0],//纬度
      cruiseSpeed: coo.cruiseSpeed,//巡航速度
      takeoffAltitude: coo.takeoffAltitude,//起飞高度
      surfaceElevation: res.data.dock_info.dockAlt,//地表海拔
      reachingAltitude: coo.takeoffAltitude + res.data.dock_info.dockAlt,//到达高度
    })

    setCoordinatePointInfo({ ...coo })
  }

  const getRoutesPoint = async () => {//获取航线信息
    let res = await getLinePointApi({ access_token: token, type: '1,7,10,11' })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }

    let arr = []
    if (res.data.length > 0) {
      res.data.forEach((res, index) => {
        let obj = {
          ...res,
          id: res.r_id || res.id,//r_id 为 标识桩   id为 管线
          fileType: 1,//文件类型   1：excel   2:kml
          points: editPipePoint(res.point_lines, 1),
        }
        arr.push(obj)
      })
    }
    getKmlRoutesPoint(arr)
  }

  const getWebSocket = async (aircraftSn, dockSn) => { // 获取 webSocket  地址
    let obj = {}
    let UAVobj = {}
    let airTime = 1
    let uavTime = 1
    let airNum = airportCoordinate[0] === 0 ? 1 : 2
    let uavNum = uavCoordinate[0] === 0 ? 1 : 2
    let res = await getWebSocketAddress({ access_token: token, type: '1' })
    if (res.ret === 200) {
      ws.current = new WebSocket(res.data);

      ws.current.onopen = (msg) => {//链接开启
        console.log("链接成功", msg);
      };

      ws.current.onmessage = e => {// 成功获取数据
        try {
          let data = JSON.parse(e.data)
          // console.log('ws的数据', data.data);

          if (data.biz_code === 'dock_osd' && data.data.sn === dockSn) {//机场
            // console.log('机场数据：', data.data, data?.data?.host?.drone_charge_state?.capacity_percent, dayjs().format('YYYY-MM-DD HH:mm:ss'));

            airTime = dayjs().valueOf()
            objectsBecomeList(data.data.host, obj)
            setAirportData({ ...obj, sn: data.data.sn })

            if (airNum === 1 && obj.longitude) {
              setAirportCoordinate([Number(obj.longitude) || 0, Number(obj.latitude) || 0])
              airNum += 1
            }
          }

          if (data.biz_code === 'device_osd' && data.data.sn === aircraftSn) {//无人机
            closeWs.current = true
            // console.log('无人机数据：', data.data, dayjs().format('YYYY-MM-DD HH:mm:ss'));
            uavTime = dayjs().valueOf()
            objectsBecomeList(data.data.host, UAVobj)
            setUAVData({ ...UAVobj, sn: data.data.sn })
            if (uavNum === 1 && UAVobj.longitude) {
              setUAVCoordinate([Number(UAVobj.longitude) || 0, Number(UAVobj.latitude) || 0])
              uavNum += 1
            }
          }

        } catch (error) {
          // message.warning('当前机场状态错误，请确认机场是否正确链接')
        }
      }

      ws.current.onerror = (msg) => {//报错信息
        // console.log('链接出错', msg)
        closeWs.current = false
        message.warning('当前ws链接网络不佳，请稍后再试···')
      }
      //链接断开
      ws.current.onclose = (msg) => {
        airNum = 1
        setAirportData({})
        setUAVData({})
        clearInterval(settime)
      }

      // 6秒一次检查当前ws传回来的数据是否还在
      let settime = setInterval(() => {
        let airTimes = Math.abs(Math.floor(dayjs().valueOf() - airTime) / 1000)
        let uavTimes = Math.abs(Math.floor(dayjs().valueOf() - uavTime) / 1000)
        if (airTimes > 6) {
          setAirportData({})
          if (closeWs.current && ws.current) {
            ws.current.close()
            ws.current = null
            getAirportNumberByToken()
          }
        }
        if (uavTimes > 6) { setUAVData({}) }
      }, 5000);
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试！')
    }
  }

  const getKmlRoutesPoint = async (list) => {//获取KML文件的航线信息
    let res = await getKmlLinePointApi({ access_token: token })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
    if (res.data.length > 0) {
      res.data.forEach((res, index) => {
        let obj = {
          ...res,
          fileType: 2,//文件类型   1：excel   2:kml
          points: editPipePoint(res.point_lines, 2),
        }
        list.push(obj)
      })
    }
    list.sort((a, b) => { return b.id - a.id })//将数据通过id进行倒叙
    setLineList([...list])
  }

  const editPipePoint = (data, fileType) => { //编辑 管线数据及标识桩数据
    if (data && data.length > 0) {
      if (fileType === 1) {
        return data.map((res, index) => {
          return [Number(res.lat_wgs84), Number(res.lon_wgs84)]
        })
      }
      if (fileType === 2) {
        let mainArr = []
        data.forEach((res) => {
          let arr = []
          res.forEach((ele, idx) => {
            arr.push([Number(ele.lat_wgs84), Number(ele.lon_wgs84)])
          })
          mainArr.push(arr)
        })
        return mainArr
      }
      return []
    } else {
      return []
    }
  }

  const objectsBecomeList = (data, list, name = null) => {//将多级objcet转换成单级objcet
    Object.keys(data).forEach(res => {
      if (typeof data[res] === 'object') {
        objectsBecomeList(data[res], list, res)
      } else {
        if (name) {
          let na = `${name}_${res}`
          list[na] = data[res]
        } else {
          list[res] = data[res]
        }
      }
    })
  }

  const GetAltitudeFun = async (arr) => {//根据经纬度获取海拔
    isCompute.current = true
    let params = {
      access_token: token,
      longitude: arr[0],
      latitude: arr[1],
    }
    let res = await GetAltitude(params);
    isCompute.current = false
    if (res.ret !== 200 || !res.data) {
      message.warning('海拔获取失败，请联系管理员或者重试');
      return 0
    } else {
      return Number(res.data[0]?.elevation)
    }

  }

  const returnBack = async () => { //返航
    let glo = globalStatus
    let coo = coordinatePointInfo
    glo.returnLoading = true
    glo.isShowPopconfirm = false
    setGlobalStatus({ ...glo })

    let res = await returnHome({ access_token: token, dock_id: dock_id, })
    if (res.ret !== 200) {
      glo.returnLoading = false
      setGlobalStatus({ ...glo })
      message.warning(res.msg || '数据跑丢了');
      return
    }
    glo.secondStatus = 7
    secondStatusRef.current = 7
    setGlobalStatus({ ...glo })

    setAnchorPoint([])
    message.success(res.msg || '返航成功')

    let point = [Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)]
    anchorPointForm.setFieldsValue({
      lng: point[0] || 0,//经度
      lat: point[1] || 0,//纬度
    })


    coo.lng = point[0] || 0
    coo.lat = point[1] || 0
    setCoordinatePointInfo({ ...coo })

    let anc = []
    anc.push([point[1], point[0]])
    anc.push([Number(UAVData?.latitude || 0), Number(UAVData?.longitude || 0)])
    setAnchorPointsList(anc)
  }

  const onFinish = async (values) => {// 指令飞行 表单提交
    if (secondStatusRef.current === 0) {//执行takeoff
      if (!Number(values.lat)) { message.warning('维度不对！'); return }
      if (!Number(values.lng)) { message.warning('经度不对！'); return }
      let obj = {
        access_token: token,
        dock_id: dock_id ? dock_id : '',//机场id
        target_latitude: values.lat,//起飞到达纬度
        target_longitude: values.lng,//起飞到达经度
        max_speed: values.cruiseSpeed,//飞行速度
        rth_altitude: values.takeoffAltitude,//起飞返航高度=>起飞高度（高度）
        target_height: values.reachingAltitude,//起飞到达海拔=>到达高度(高度+海拔)
      }
      let res = await goToPointByTakeoff(obj)
      if (res.ret !== 200) {
        message.warning(res.msg || '数据跑丢了')
        takeoffLoadingRef.current = false
        return
      }
      takeoffLoadingRef.current = true
      secondStatusRef.current = 1
      message.success(res.msg || '执行takeoff成功')
    }

    if (secondStatusRef.current === 4) { //执行flyto
      let obj = {
        access_token: token,
        dock_id: dock_id ? dock_id : '',//机场id
        latitude: values.lat,//起飞到达纬度
        longitude: values.lng,//起飞到达经度
        max_speed: values.cruiseSpeed,//飞行速度
        height: values.reachingAltitude,//高度->飞行海拔(高度+海拔)
      }

      let res = await goToPointByFlyTo(obj)
      flytoLoadingRef.current = false
      if (res.ret !== 200) {
        message.warning(res.msg || '数据跑丢了')
        return
      }

      flytoLoadingRef.current = true
      secondStatusRef.current = 2
      message.success(res.msg || '执行flyto成功')
    }

    let anc = []
    anc.push([values.lat, values.lng])
    anc.push([Number(UAVData?.latitude || 0), Number(UAVData?.longitude || 0)])
    setAnchorPointsList(anc)
  }

  const showMap = (centerPoint) => {//展示地图并标注机场
    mapRef.current = demoMap(centerPoint)
    mapRef.current.on('click', async (e) => {
      if (([3, 4].indexOf(secondStatusRef.current) > -1 && !taskLoadingRef.current && droneStatusRef.current === 'A')) {
        let value = { lng: Number(e.latlng.lng.toFixed(6)), lat: Number(e.latlng.lat.toFixed(6)), }
        let coo = { ...coordinatePointInfo }
        setAnchorPoint([value.lng, value.lat])//当前点击的位置
        localStorage.setItem('dock_anchorPoint', [value.lng, value.lat]);
        coo.lng = value.lng
        coo.lat = value.lat
        coo.surfaceElevation = [0, 1].indexOf(secondStatusRef.current) > -1 ? coo.takeoffElevation : await GetAltitudeFun([value.lng, value.lat])
        coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
        // 创建定位点后将默认值写入表单
        anchorPointForm.setFieldsValue({
          lng: value.lng,//经度
          lat: value.lat,//纬度
          cruiseSpeed: coo.cruiseSpeed,//巡航速度
          takeoffAltitude: coo.takeoffAltitude,//起飞高度
          surfaceElevation: coo.surfaceElevation,//地表海拔
          reachingAltitude: coo.reachingAltitude,//到达高度
        })
        setCoordinatePointInfo({ ...coo })
        let glo = globalStatus
        glo.firstStatus = mainStatusRef.current
        glo.secondStatus = 4
        secondStatusRef.current = 4
        setGlobalStatus({ ...glo })
      }
    })
    getAirportNumberByToken()
  }

  const UAVTypeInfoReturn = (value) => { //无人机状态详情  回调
    droneStatusRef.current = value.droneStatus
    setMegaphoneType(value.megaphoneType || 0)
  }

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('dock_DefaultMapPoints'))) {
      showMap(JSON.parse(localStorage.getItem('dock_DefaultMapPoints')))
    } else {
      showMap(undefined)
    }

    return () => {
      if (ws.current) {//如果websoket存在  在切换页面时将其关闭
        closeWs.current = false
        ws.current.close()
        ws.current = null
      }
    }

    // eslint-disable-next-line
  }, [])

  // -----------------------------------------本地化-------------------------------------------------------------

  const dock_marker_Ref = useRef(null)//机场  图标实例
  useEffect(() => {
    // 机场位置
    if (airportData?.longitude && airportData?.longitude > 0) {

      if (dock_marker_Ref.current) { dock_marker_Ref.current.remove(); dock_marker_Ref.current = null }

      let dockIcon = BM.icon({
        iconUrl: map_jc,
        iconSize: [18, 18],
        iconAnchor: [9, 9],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });
      dock_marker_Ref.current = BM.marker([Number(airportData?.latitude || 0), Number(airportData?.longitude || 0)], { draggable: false, icon: dockIcon, }).addTo(mapRef.current)
      dock_marker_Ref.current.on('mouseover', (e) => {
        dock_marker_Ref.current.unbindTooltip()
        dock_marker_Ref.current.bindTooltip(`${dockInfo?.id}-${dockInfo?.dockName}`, { direction: 'top', offset: [0, -16] }).openTooltip([e.latlng.lat, e.latlng.lng]);
      })
      dock_marker_Ref.current.on('mouseout', (e) => { dock_marker_Ref.current.unbindTooltip() })
    }
    // eslint-disable-next-line 
  }, [airportData])

  const dock_circle_Ref = useRef(null)//机场  范围实例
  useEffect(() => {
    if (airportData?.longitude && airportData?.longitude > 0) {
      if (dock_circle_Ref.current) { dock_circle_Ref.current.remove(); dock_circle_Ref.current = null }
      if (mainStatusRef.current === 1) { return }
      dock_circle_Ref.current = BM.circle([Number(airportData?.latitude || 0), Number(airportData?.longitude || 0)], { radius: dockInfo.radius, fill: false, color: 'red', weight: 2 }).addTo(mapRef.current)
      dock_circle_Ref.current.on('mouseover', (e) => {
        dock_circle_Ref.current.unbindTooltip()
        dock_circle_Ref.current.bindTooltip(`${dockInfo.dockName} 设置范围：${dockInfo.radius}m`, { direction: 'top', offset: [0, -16] }).openTooltip([e.latlng.lat, e.latlng.lng]);
      })
      dock_circle_Ref.current.on('mouseout', (e) => { dock_circle_Ref.current.unbindTooltip() })

    }
    // eslint-disable-next-line 
  }, [airportData, mainStatus])

  useEffect(() => {//所有管线 及其 标识桩
    if (lineList.length > 0) {
      lineList.forEach((res, index) => {
        if (res.pipe_type === 1) {//管线
          BM.polyline(res.points, { color: '#FFBD0A', }).addTo(mapRef.current)
        }

        if (res.pipe_type === 3 && res.point_lines.length > 0) {//标识桩
          res.point_lines.forEach(ele => {
            let stakeIcon = BM.divIcon({
              className: '',
              iconAnchor: [0, 0],//[左右，上下]
              zIndexOffset: -1000,
              html: `
              <div>
              <img class="shadow pos_abs " src="${peg}" alt="标识桩" style="top: -93px; left: -14px;"/>
              <div class="pegpoint pos_abs  h17 w78 flex jcc align_center" style="top: -58px; left: -38px; color: rgb(0, 0, 0);">${ele.pt_name}</div></div>
              `
            });
            BM.marker([ele.lat_wgs84, ele.lon_wgs84], { draggable: false, icon: stakeIcon, title: res.pt_name, zIndex: 1 }).addTo(mapRef.current)
          })
        }
      })
    }
  }, [lineList])

  useEffect(() => {//航点坐标
    if (pipelineAndPoint.waypointCoordinates.length > 0) {
      pipelineAndPoint.waypointCoordinates.forEach((res, index) => {
        let linePointIcon = BM.divIcon({
          className: '',
          iconAnchor: [15, 10],//[左右，上下]
          zIndexOffset: -1000,
          html: `
          <div
          class='w30 h20 border flex jcc align_center radius4'
          style='background-color:#FFBD0A'>
          <span class='fs12 fw600 lh18' style='color:#000'>${index + 1}</span>
        </div>
            `
        });

        BM.marker([res[1], res[0]], { draggable: false, icon: linePointIcon, title: '航点' }).addTo(mapRef.current)
      })
    }

    if (pipelineAndPoint.pipeline.length > 0) {
      BM.polyline(pipelineAndPoint.pipeline.map((res) => { return [res[1], res[0]] }), { color: '#FFBD0A', }).addTo(mapRef.current)
    }
  }, [pipelineAndPoint])

  const marker_UAVPointRef = useRef(null)//无人机箭头 实例
  useEffect(() => {
    if (marker_UAVPointRef.current) {
      marker_UAVPointRef.current.remove()
      marker_UAVPointRef.current = null
    }
    if (UAVData.longitude) {
      let UAVIcon = BM.icon({
        iconUrl: map_uavJT,
        iconSize: [24, 24],
        iconAnchor: [12, 12],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });
      marker_UAVPointRef.current = BM.marker([UAVData.latitude, UAVData.longitude], { draggable: false, icon: UAVIcon, title: '无人机', rotationAngle: UAVData?.attitude_head, })
        .setZIndexOffset(950)
        .addTo(mapRef.current)
    }

    // eslint-disable-next-line
  }, [UAVData.latitude, UAVData?.attitude_head])

  const marker_anchorPoint = useRef(null)//当前点击  flyto的位置
  useEffect(() => {
    if (marker_anchorPoint.current) {
      marker_anchorPoint.current.remove()
      marker_anchorPoint.current = null
    }
    if (anchorPoint.length > 0) {
      let pointIcon = BM.icon({
        iconUrl: map_dd,
        iconSize: [36, 36],
        iconAnchor: [18, 30],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });

      marker_anchorPoint.current = BM.marker([anchorPoint[1], anchorPoint[0]], { draggable: false, icon: pointIcon, }).setZIndexOffset(920).addTo(mapRef.current)

      marker_anchorPoint.current.on('mouseover', (e) => {
        marker_anchorPoint.current.unbindTooltip()
        marker_anchorPoint.current.bindTooltip('目标位置', { direction: 'top', offset: [0, -32] }).openTooltip([e.latlng.lat, e.latlng.lng]);
      })
      marker_anchorPoint.current.on('mouseout', (e) => { marker_anchorPoint.current.unbindTooltip() })

    }


    // eslint-disable-next-line
  }, [anchorPoint])

  const clickLine_anchorPoint = useRef(null)//当前点击的线段  
  useEffect(() => {
    if (anchorPointsList.length < 2) { return }
    if (clickLine_anchorPoint.current) {
      clickLine_anchorPoint.current.remove()
      clickLine_anchorPoint.current = null
    }

    clickLine_anchorPoint.current = BM.polyline(anchorPointsList?.map(res => { return [res[1], res[0]] }), { color: '#FFBD0A', }).addTo(mapRef.current)

    // eslint-disable-next-line
  }, [anchorPointsList])

  // -----------------------------------------本地化-------------------------------------------------------------
  useEffect(() => {  // 无人机状态 监听

    let coo = { ...coordinatePointInfo }
    let glo = globalStatus
    let point = [Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)]
    if (JSON.stringify(UAVData) === '{}') {
      glo.secondStatus = 0
      secondStatusRef.current = 0
      setGlobalStatus({ ...glo })
      return
    }


    let ddd = []
    ddd.push(`${UAVData?.mode_code}_${uav_mode_code_dic[UAVData?.mode_code]}_${dayjs().format('HH:mm:ss')}`)
    uav_mode_code_state.current = uav_mode_code_dic[UAVData?.mode_code]

    switch (UAVData?.mode_code) {
      case 0://待机
        if (mainStatusRef.current === 1) {
          droneStatusRef.current = 'P'
        }
        coo.lng = point[0]
        coo.lat = point[1]
        coo.surfaceElevation = coo.takeoffElevation
        coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
        // 创建定位点后将默认值写入表单
        anchorPointForm.setFieldsValue({
          lng: point[0],//经度
          lat: point[1],//纬度
          cruiseSpeed: coo.cruiseSpeed,//巡航速度
          takeoffAltitude: coo.takeoffAltitude,//起飞高度
          surfaceElevation: coo.surfaceElevation,//地表海拔
          reachingAltitude: coo.reachingAltitude,//到达高度
        })
        setCoordinatePointInfo({ ...coo })
        glo.secondStatus = 0
        secondStatusRef.current = 0
        glo.returnLoading = false
        setGlobalStatus({ ...glo })
        setCoordinatePointInfo({ ...coo })
        break;

      case 1://起飞准备
        droneStatusRef.current = 'A'
        monitor_statusRef.current = 1
        glo.secondStatus = 1
        secondStatusRef.current = 1
        glo.taskLoading = true
        taskLoadingRef.current = true
        setGlobalStatus({ ...glo })
        break;

      case 3://手动飞行

        if (mainStatusRef.current === 1) {
          monitor_statusRef.current = 2
          droneStatusRef.current = 'P'
        }

        glo.secondStatus = 3
        secondStatusRef.current = 3
        glo.taskLoading = false
        taskLoadingRef.current = false
        takeoffLoadingRef.current = false
        flytoLoadingRef.current = false
        glo.returnLoading = false
        setGlobalStatus({ ...glo })

        if (anchorPointsList.length < 1) {
          coo.lng = point[0]
          coo.lat = point[1]
          coo.surfaceElevation = coo.takeoffElevation
          coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
          // 创建定位点后将默认值写入表单
          anchorPointForm.setFieldsValue({
            lng: point[0],//经度
            lat: point[1],//纬度
            cruiseSpeed: coo.cruiseSpeed,//巡航速度
            takeoffAltitude: coo.takeoffAltitude,//起飞高度
            surfaceElevation: coo.surfaceElevation,//地表海拔
            reachingAltitude: coo.reachingAltitude,//到达高度
          })
          setCoordinatePointInfo({ ...coo })
          let anc = []
          anc.push([Number(UAVData?.longitude || 0), Number(UAVData?.latitude || 0)])
          setAnchorPointsList([...anc])
        }



        break;

      case 5://航线飞行
        if (mainStatusRef.current === 1) {
          droneStatusRef.current = 'A'
          monitor_statusRef.current = 1
        }
        break;

      case 9://自动返航
        glo.secondStatus = 7
        secondStatusRef.current = 7
        setGlobalStatus({ ...glo })
        setAnchorPoint([Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)])
        monitor_statusRef.current = 1
        break;

      case 10://自动降落
        glo.secondStatus = 7
        secondStatusRef.current = 7
        setGlobalStatus({ ...glo })
        setAnchorPoint([Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)])
        break;

      case 17://指令飞行
        droneStatusRef.current = 'A'
        if (secondStatusRef.current === 0) {
          glo.secondStatus = 1
          secondStatusRef.current = 1
          setGlobalStatus({ ...glo })
        }

        if (secondStatusRef.current === 4) {
          glo.secondStatus = 2
          secondStatusRef.current = 2
          setGlobalStatus({ ...glo })
        }
        break;

      default:
        if (!airportData.drone_in_dock) {//无人机不在机场内  默认已经在任务中
          glo.secondStatus = 3
          secondStatusRef.current = 3
          setGlobalStatus({ ...glo })
        }
        break;
    }

    return () => {


    }

    // eslint-disable-next-line
  }, [UAVData?.mode_code])

  return (
    <div className='pos_rel' style={{ width: '100vw', height: '100vh' }}>
      <>{/* 地图 */}
        <div id='map' className='hei100' />
      </>

      <>{/* 机场  状态栏 */}
        {
          airportData &&
          <div className='pos_abs wid100' style={{ top: 0, left: 0 }}>
            <AirportTypeInfo dock_id={dock_id} UAVData={UAVData} airportData={airportData} />
          </div>
        }
      </>

      <>{/* 机场健康状态 */}
        {
          dock_id &&
          <div className='pos_abs' style={{ top: 0, left: 'calc(50% - 140px)' }}>
            <AirportHealthStatus dock_id={dock_id} />
          </div>
        }
      </>

      <>{/* 直播 */}
        {
          JSON.stringify(UAVData) !== '{}' &&
          <div className='pos_abs' style={{ bottom: 16, left: 16 }}>
            <LiveVideo dock_id={dock_id} pitchAngle={UAVData['0_gimbal_pitch']} />
          </div>
        }
      </>

      <>{/* 右下角集合 操作及状态按钮 */}
        <div className='pos_abs flex_col jcc align_center marR' style={{ bottom: 0, right: 16 }}>
          <>{/* 无人机  状态栏 */}
            {
              JSON.stringify(UAVData) !== '{}' &&
              <div className='w280 hei100 marB16'>
                <UAVTypeInfo
                  UAVData={UAVData}
                  airportData={airportData}
                  droneStatus={droneStatusRef.current}
                  mainStatus={mainStatusRef.current}
                  returnBack={UAVTypeInfoReturn}
                />
              </div>
            }
          </>

          <>{/* 操作盘 */}
            {
              JSON.stringify(UAVData) !== '{}' &&
              droneStatusRef.current === 'M' &&
              mainStatusRef.current === 2 &&
              [3, 16].indexOf(Number(UAVData?.mode_code)) > -1 &&
              <div className='w280 marB16'>
                <Operator
                  dockId={dock_id}
                  sn={airportData?.sn}
                />
              </div>
            }
          </>

          <>{/* 主操作 按键||表单 */}
            {
              <Card
                className='w280 marB16'
                style={{ border: 0 }}
                styles={{ body: { padding: 24 } }}>
                <>{/* 表单 */}
                  {
                    <>
                      <Form
                        className='wid100'
                        form={anchorPointForm}
                        name='form'
                        style={{
                          display:
                            (mainStatusRef.current === 2//状态为指令
                              &&
                              (
                                [0, 1, 2, 4, 17].indexOf(Number(UAVData?.mode_code)) > -1//起飞状态
                                || droneStatusRef.current === 'A'//指点飞行状态
                                || takeoffLoadingRef.current//起飞中
                                || (JSON.stringify(airportData) !== '{}' && JSON.stringify(UAVData) === '{}')//
                              )
                              ? ''
                              : 'none'
                            )
                        }}
                        onFinish={onFinish}>
                        <Form.Item
                          style={{ margin: '0 0 8px 0' }}
                          label="经度"
                          name="lng" rules={[{ required: true, message: '请输入经度', }]}>
                          <InputNumber
                            disabled={[0, 1].indexOf(secondStatusRef.current) > -1}
                            className='wid100'
                            placeholder="-"
                            step={0.001}
                            onChange={async (e) => {

                            }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ margin: '0 0 8px 0' }}
                          label="纬度"
                          name="lat"
                          rules={[{ required: true, message: '请输入纬度', }]}>
                          <InputNumber
                            disabled={[0, 1].indexOf(secondStatusRef.current) > -1}
                            className='wid100'
                            placeholder="-"
                            step={0.001}
                            onChange={async (e) => {

                            }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ margin: '0 0 8px 0', }}
                          label="巡航速度"
                          name="cruiseSpeed"
                          rules={[{ required: true, message: '请输入速度', }]}
                        >
                          <InputNumber
                            addonAfter="m/s"
                            placeholder='-'
                            onChange={(e) => {
                              let coo = coordinatePointInfo
                              coo.cruiseSpeed = e
                              setCoordinatePointInfo({ ...coo })
                            }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ margin: '0 0 8px 0' }}
                          label={`${[0, 1].indexOf(secondStatusRef.current) > -1 ? '起飞高度' : '飞行高度'}`}
                          name="takeoffAltitude"
                          rules={[{ required: true, message: '请输入起飞高度', }]}
                        >
                          <InputNumber
                            addonAfter="m"
                            placeholder='-'
                            onChange={(e) => {
                              let coo = coordinatePointInfo
                              coo.takeoffAltitude = e
                              coo.reachingAltitude = Number(e) + Number(coo.surfaceElevation)
                              anchorPointForm.setFieldsValue({
                                takeoffAltitude: e,//地表海拔
                                reachingAltitude: Number(e) + Number(coo.surfaceElevation),
                              })
                              setCoordinatePointInfo({ ...coo })
                            }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ margin: '0 0 8px 0' }}
                          label={`${[0, 1].indexOf(secondStatusRef.current) > -1 ? '机场海拔' : '地表海拔'}`}
                          name="surfaceElevation"
                          rules={[{ required: true, message: `请输入${[0, 1].indexOf(secondStatusRef.current) > -1 ? '机场海拔' : '地表海拔'}`, }]}
                        >
                          <div className='flex'>
                            <InputNumber
                              value={
                                [0, 1].indexOf(secondStatusRef.current) > -1
                                  ? coordinatePointInfo.takeoffElevation
                                  : coordinatePointInfo.surfaceElevation
                              }
                              disabled={[0, 1].indexOf(secondStatusRef.current) > -1}
                              addonAfter="m"
                              placeholder='-'
                              onChange={(e) => {
                                let coo = coordinatePointInfo
                                coo.surfaceElevation = e
                                coo.reachingAltitude = Number(e) + Number(coo.takeoffAltitude)
                                anchorPointForm.setFieldsValue({
                                  surfaceElevation: coo.surfaceElevation,//地表海拔
                                  reachingAltitude: coo.reachingAltitude,
                                })
                                setCoordinatePointInfo({ ...coo })
                              }}
                            />
                            <div>
                              {/* 刷新地表海拔 */}
                              <Button
                                disabled={[0, 1].indexOf(secondStatusRef.current) > -1}
                                className='marL8 wid100'
                                icon={<SyncOutlined />}
                                onClick={async () => {
                                  let coo = coordinatePointInfo
                                  coo.surfaceElevation = await GetAltitudeFun(anchorPoint)
                                  coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
                                  anchorPointForm.setFieldsValue({
                                    surfaceElevation: coo.surfaceElevation,//地表海拔
                                    reachingAltitude: coo.reachingAltitude,
                                  })
                                  setCoordinatePointInfo({ ...coo })
                                }}
                              />
                            </div>
                          </div>
                        </Form.Item>

                        <Form.Item
                          style={{ margin: '0 0 8px 0' }}
                          label={`${[0, 1].indexOf(secondStatusRef.current) > -1 ? '到达高度' : '飞行海拔'}`}
                          name="reachingAltitude"
                          rules={[{ required: true, message: '请输入到达高度', }]}
                        >
                          <InputNumber
                            disabled
                            addonAfter="m"
                            placeholder='-'
                            value={Number(coordinatePointInfo.reachingAltitude)}
                          />
                        </Form.Item>

                        <Button
                          id='anchorPointFormSubmit'
                          type="primary"
                          htmlType="submit"
                          style={{ display: 'none' }}
                        >
                          提交表单
                        </Button>
                      </Form>
                    </>
                  }

                </>

                <>{/* 按钮集合 */}

                  <>{/* 一级  按钮 */}
                    {
                      mainStatusRef.current === 2 &&
                      <>{/* A */}
                        <>{/* 任务中 */}
                          {
                            droneStatusRef.current === 'A' && [5, 17].indexOf(Number(UAVData?.mode_code)) > -1 &&
                            <Button
                              type='primary'
                              className='wid100 marB8'
                              icon={<LoadingOutlined />}
                            >
                              任务中···
                            </Button>
                          }
                        </>

                        <>{/* 起飞 */}
                          {
                            JSON.stringify(airportData) !== '{}' &&
                            (JSON.stringify(UAVData) === '{}' || [0, 1, 2, 4, 14].indexOf(Number(UAVData?.mode_code)) > -1) &&
                            <Button
                              type='primary'
                              className='wid100 marB8'
                              disabled={!airportData?.drone_in_dock}
                              icon={takeoffLoadingRef.current ? <LoadingOutlined /> : <CaretRightOutlined />}
                              onClick={() => {
                                if (!takeoffLoadingRef.current) { document.getElementById("anchorPointFormSubmit").click() }
                              }}
                            >
                              {takeoffLoadingRef.current ? '起飞中···' : '起飞'}
                            </Button>
                          }
                        </>

                        <>{/* 前往航点 */}
                          {
                            mainStatusRef.current === 2 && droneStatusRef.current === 'A' && Number(UAVData?.mode_code) === 3 &&
                            <Button
                              type='primary'
                              className='wid100 marB8'
                              disabled={secondStatusRef.current !== 4}
                              icon={<CaretRightOutlined />}
                              onClick={() => { document.getElementById("anchorPointFormSubmit").click() }}
                            >
                              前往航点
                            </Button>
                          }
                        </>
                      </>
                    }
                  </>

                  <>{/* 二级  按钮 */}
                    {
                      // JSON.stringify(UAVData) !== '{}' &&
                      <div className='flex jcsb align_center marB8'>
                        <>
                          {/* 监控 */}{
                            mainStatusRef.current === 1 &&
                            <>{/* 暂停|继续 */}
                              <Button
                                className='w112'
                                type='primary'
                                disabled={[0, 9, 10].indexOf(UAVData.mode_code) > -1 || JSON.stringify(UAVData) === '{}' || pipelineAndPoint.waypointCoordinates.length === 0}
                                icon={monitor_statusRef.current === 1 ? [9, 10].indexOf(Number(UAVData?.mode_code)) > -1 ? <LoadingOutlined /> : <PauseOutlined /> : <CaretRightOutlined />}
                                onClick={async () => {
                                  if (monitor_statusRef.current === 1) {//暂停
                                    let res = await updateJobStatusAPI({
                                      access_token: token,
                                      dock_id: dock_id,
                                      status: 0,
                                    })
                                    if (res.ret !== 200) {
                                      message.warning(res.msg || `暂停失败`)
                                      return
                                    }
                                    message.success(res.msg || '暂停成功')

                                  } else if (monitor_statusRef.current === 2) {//继续飞行
                                    let res = await updateJobStatusAPI({
                                      access_token: token,
                                      dock_id: dock_id,
                                      status: 1,
                                    })
                                    if (res.ret !== 200) {
                                      message.warning(res.msg || `继续执行失败`)
                                      return
                                    }
                                    message.success(res.msg || '继续执行成功')
                                  }
                                  monitor_statusRef.current = monitor_statusRef.current === 1 ? 2 : 1
                                }}
                              >
                                {monitor_statusRef.current === 1 ? '暂停' : '继续飞行'}
                              </Button>
                            </>
                          }

                          {/* 指令 */}{
                            mainStatusRef.current === 2 &&
                            <>{/* 停止 */}
                              <Button
                                className='w112'
                                icon={<StopOutlined />}
                                disabled={[1, 2, 4, 5, 9, 17].indexOf(Number(UAVData?.mode_code)) < 0}
                                onClick={async () => {

                                  if (Number(UAVData?.mode_code) === 17) {//指令飞行
                                    let res = await stopFlytoAPI({//取消flyto
                                      access_token: token,
                                      dock_id: dock_id,
                                    })
                                    if (res.ret !== 200) { message.warning(res.msg || '停止失败'); return }
                                    setAnchorPoint([])
                                    setAnchorPointsList([])
                                    message.success(res.msg || '停止成功')
                                  }

                                  if (Number(UAVData?.mode_code) === 9) {//自动返航
                                    let res = await cancelReturnFlightAPI({//取消返航
                                      access_token: token,
                                      dock_id: dock_id,
                                    })
                                    if (res.ret !== 200) { message.warning(res.msg || '停止返航失败'); return }
                                    setAnchorPoint([])
                                    setAnchorPointsList([])
                                    message.success(res.msg || '停止返航成功')
                                  }
                                }}
                              >
                                {Number(UAVData?.mode_code) === 9
                                  ? '停止返航'
                                  : '停止'
                                }
                              </Button>
                            </>
                          }
                        </>

                        {/* 返航 */}{
                          <Popconfirm
                            open={mainStatusRef.current === 1 && globalStatus.isShowPopconfirm}
                            title="返航"
                            description={
                              <div>
                                <span>
                                  结束当前飞行任务，将无人机返航？
                                </span>
                                <div style={{ color: '#DC4446' }}>
                                  注：执行返航后，后续任务将不再执行，
                                  <div>亦不可取消返航</div>
                                </div>
                              </div>
                            }
                            onConfirm={async () => { returnBack() }}
                            onCancel={() => {
                              let glo = globalStatus
                              glo.isShowPopconfirm = false
                              setGlobalStatus({ ...glo })
                            }}
                            okText="确定返航"
                            cancelText="取消返航"
                          >
                            <Button
                              className='w112'
                              icon={<VerticalAlignBottomOutlined />}
                              disabled={[3, 4, 5, 17].indexOf(Number(UAVData?.mode_code)) < 0}
                              onClick={() => {
                                if (mainStatusRef.current === 1) {
                                  let glo = globalStatus
                                  glo.isShowPopconfirm = true
                                  setGlobalStatus({ ...glo })
                                } else {
                                  returnBack()
                                }
                              }}
                            >
                              返航
                            </Button>
                          </Popconfirm>
                        }

                      </div>
                    }
                  </>

                  <>{/* 切换主状态  1、监控   2、指令 */}
                    {
                      Number(localStorage.getItem('dock_memberLevel')) === 255 &&
                      <Button
                        className='wid100'
                        icon={<SwapOutlined />}
                        disabled={[0, 3,].indexOf(UAVData.mode_code) < 0 && JSON.stringify(UAVData) !== '{}'}
                        onClick={() => {
                          mainStatusRef.current = mainStatusRef.current === 1 ? 2 : 1
                          setMainStatus(mainStatusRef.current === 1 ? 2 : 1)
                        }}
                      >
                        {`切换${mainStatusRef.current === 1 ? '指令' : '监控'}`}
                      </Button>
                    }
                  </>
                </>
              </Card>
            }
          </>
        </div >
      </>

      <>{/* 喊话器、实时状态 */}
        {
          JSON.stringify(UAVData) !== '{}' &&
          <div className='pos_abs' style={{ bottom: 16, left: "calc(50% - 200px)" }}>
            <>{/* 喊话器 */}
              {
                megaphoneType !== 0 && [3, 16].indexOf(UAVData?.mode_code) > -1 &&
                <Megaphone
                  type={megaphoneType}
                  dockId={dock_id}
                  sn={airportData?.sn}
                />

              }
            </>

            <>{/* 无人机返回状态 */}
              <Card className='marT16' style={{ border: 0 }} styles={{ body: { padding: 0, width: 400 } }}>
                <div className='marTB16 marRL24 flex jcsb align_center'>
                  <div className='fs20 fw600 lh25'>
                    {uav_mode_code_state.current}
                  </div>
                </div>
              </Card>
            </>
          </div>
        }
      </>

    </div >
  )
}
export default SurveillanceInfo;